import useLocalStorage from '@kk/shared/hooks/useLocalStorage';
import { useExternalUserInfo } from '#/api/hooks/useUserInfo';

export type SavedSearch = {
  contractNumber: string;
  loanType: string;
  maturityDate: string;
};

const ITEM_LIMIT = 5;

export function useSavedSearch() {
  const { data: user } = useExternalUserInfo();
  const [savedSearches, setSavedSearches] = useLocalStorage<{
    loans: SavedSearch[];
  }>(`${user?.idpId}${user?.cvr}.searchHistory`, {
    loans: [],
  });

  function addSavedSearch(result: SavedSearch) {
    try {
      if (
        savedSearches.loans.some(
          (item) => item.contractNumber === result.contractNumber,
        )
      ) {
        const newSavedSearLoans = savedSearches.loans.filter(
          (item) => item.contractNumber !== result.contractNumber,
        );
        newSavedSearLoans.unshift(result);
        setSavedSearches({
          loans: newSavedSearLoans,
        });
      } else {
        const loans = [...savedSearches.loans];
        if (loans.length >= ITEM_LIMIT) {
          loans.pop();
        }
        setSavedSearches({
          loans: [result, ...loans],
        });
      }
    } catch (e) {
      console.error(e);
    }
  }

  return {
    savedSearches,
    addSavedSearch,
  };
}
